<template>
    <section  class="cart-sec">
        <div v-if="show" class="cart-sec__promo">
            <input v-model="promo"  type="text" :placeholder="this.trans('enter the promo code')" class="cart-sec__promo-input">
            <button @click="getPromo" class="btn btnV2 basket-success" id="basket-success">{{ trans('Apply') }}</button>
        </div>
    </section>
</template>

<script>
export default {
    name: "promo",
    props: {
        show: {
            type: Boolean,
            required: true,
        },
    },
    data(){
        return{
            promo:''
        }
    },
    methods:{
        async getPromo(){
            const code = (this.promo || '').trim()
            if (!code) {
                this.$notify({
                    title: this.trans('Notification'),
                    text: this.trans('enter the promo code'),
                    type: 'warning',
                })
                return
            }
            await axios.get('/api/v1/get-promo', {
                params: this.setParam({
                    promo: code,
                    guest_id: this.$store.state.settings.guest.id,
                }),
            })
                .then((response) => {
                    const data = response.data
                    this.$notify({
                        title: data.title,
                        text: data.text,
                        type: data.status,
                    })
                    if (data.status === 'success' && data.promo?.promo_token) {
                        localStorage.setItem('promo_token', data.promo.promo_token)
                        localStorage.setItem('promo', JSON.stringify(data.promo))
                        this.$store.state.settings.promo = data.promo
                        this.promo = ''
                        this.$parent.getBasket()
                    }
                })
                .catch((err) => {
                    const msg = err.response?.data?.message
                        || err.response?.data?.text
                        || this.trans('Server error')
                    this.$notify({
                        title: this.trans('Error'),
                        text: typeof msg === 'string' ? msg : this.trans('Server error'),
                        type: 'error',
                    })
                })
        },
    }
}
</script>

<style scoped>

</style>
